module.exports = __webpack_public_path__ + "kerbin/app/images/signup/people.4c999636.jpg";